import * as styles from './notes-empty-hint.css';

export const NotesEmptyHint = () => (
  <div className={styles.root}>
    <div className={styles.subtitle}>
      Click <span className={styles.accent}>New Note</span> above to get
      started
    </div>
  </div>
);
